import { CanActivateFn, ResolveFn, Router, Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { inject } from '@angular/core';
import { ChamadaEtapaPerfilService } from '../../shared/services/chamada-etapa-perfil.service';
import { LoadingService } from '../../shared/services/loading.service';
import { catchError, finalize, forkJoin, map, Observable, of } from 'rxjs';
import { UsuarioService } from '../../shared/services/usuario.service';
import { AlertService } from '../../shared/services/alert.service';
import { MaisMedicosService } from '../../shared/services/maismedicos.service';
import { AuthService } from '../../shared/services/auth.services';

const inscricaoResolver: ResolveFn<any> = () => {
  const loadingService = inject(LoadingService);
  const usuarioService = inject(UsuarioService);
  const chamadaEtapaPerfilService = inject(ChamadaEtapaPerfilService);

  loadingService.open();
  return forkJoin({
    usuario: usuarioService.current(),
    chamadaEtapaPerfil:
      chamadaEtapaPerfilService.fetchByEtapaFaseAdesaoProfissionalVigente(),
  }).pipe(finalize(() => loadingService.close()));
};

const gestorGuard: CanActivateFn = (_route, _state): Observable<boolean> => {
  const usuarioService = inject(UsuarioService);
  const loadingService = inject(LoadingService);
  const alertService = inject(AlertService);
  const router = inject(Router);

  loadingService.open();
  return usuarioService.current().pipe(
    catchError(() => of(null)),
    map((usuario) => {
      if (!usuario) return false;
      if (
        usuario.relPerfis.some((up) =>
          up.perfil.nome.toUpperCase().match('GESTOR'),
        )
      ) {
        alertService.warning(
          'Conforme regras do edital vigente, acesso a inscrição não permitido. O CPF informado possui perfil ativo de Gestor Municipal.',
        );
        router.navigate(['/']);
        return false;
      }
      return true;
    }),
    finalize(() => loadingService.close()),
  );
};

const profissionalAtivoGuard: CanActivateFn = (
): Observable<boolean> => {
  const maismedicosService = inject(MaisMedicosService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const loadingService = inject(LoadingService);

  loadingService.open();

  return maismedicosService
    .consultarProfissionalAtivo(authService.getUserInfo()?.username || '')
    .pipe(
      catchError((error: any) => {
        if (error.status === 404) return of(true);
        router.navigate(['/']);
        return of(false);
      }),
      map((value) => {
        if (value !== true) {
          alertService.warning(
            'Conforme regras do edital vigente, acesso a inscrição não permitido. Profissional já atuando no programa Mais Médicos.',
          );
          router.navigate(['/']);
          return false;
        }
        return true;
      }),
      finalize(() => loadingService.close()),
    );
};

const profissionalDesligadoGuard: CanActivateFn = (
): Observable<boolean> => {
  const maismedicosService = inject(MaisMedicosService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const loadingService = inject(LoadingService);

  loadingService.open();

  return maismedicosService
    .consultarProfissionalDesligado(authService.getUserInfo()?.username || '')
    .pipe(
      catchError(() => of(null)),
      map((response) => {
        if (response?.isDesligado) {
          const mensagem = response.mensagem?.match(/administrativo/)
            ? 'Conforme regras do edital vigente, acesso a inscrição não permitido. O CPF informado esta  com registro de desligamento administrativo.'
            : 'Conforme regras do edital vigente, acesso a inscrição não permitido. O CPF informado possui registro de desligamento com menos de 180 dias.';
          alertService.warning(mensagem);
          router.navigate(['/']);
          return false;
        }
        return true;
      }),
      finalize(() => loadingService.close()),
    );
};

export const inscricaoRoutes: Routes = [
  /*{
    path: 'cadastro-profissional',
    canActivate: [
      AuthGuard,
      //gestorGuard,
      //profissionalAtivoGuard,
      //profissionalDesligadoGuard,
    ],
    data: {
      title: 'Cadastro do Profissional',
      breadcrumb: [
        { label: 'Cadastro do Profissional', url: '/cadastro-profissional' },
      ],
    },
    resolve: {
      data: inscricaoResolver,
    },
    loadComponent: () =>
      import('./inscricao.component').then((m) => m.InscricaoComponent),
  },*/
  {
    path: 'cadastro-profissional/:cicloId',
    canActivate: [
      AuthGuard,
      gestorGuard,
      profissionalAtivoGuard,
      profissionalDesligadoGuard,
    ],
    data: {
      title: 'Cadastro do Profissional',
      breadcrumb: [
        { label: 'Cadastro do Profissional', url: '/cadastro-profissional' },
      ],
    },
    resolve: {
      data: inscricaoResolver,
    },
    loadComponent: () =>
      import('./inscricao.component').then((m) => m.InscricaoComponent),
  },
];
